import { uploader } from '@gem/modules/file-upload';
import { logger } from '@gem/modules/logger';

import Entities from 'STORE';

export default async ({ preview, channelId, fileName }) => {
  try {
    if (!Entities.ActiveStream.stream?.previewImageUrl) {
      if (preview) {
        const { uploadUrl, publicUrl, headers } = await uploader.getUploadUrlData(
          fileName,
          preview.type || ''
        );
        if (uploadUrl) {
          preview.name = channelId;
          await uploader.uploadFile(uploadUrl, preview, fileName, headers);
          Entities.ActiveStream.stream.updateStream({
            publicUrl,
          });
        }
      }
    }
  } catch (e) {
    logger.get('API').error('streams.updateStreamInfo', e);
    return null;
  }
};
